export const colors = {
  text: {
    primary: "#2D2D2D",
    secondary: "#8A8A8A",
  },
  accents: {
    main: "#fdd000",
    hover: "#fceaa3",
    phone: "#08c",
    taxiClass: "#ebb2bc",
    important: "#b94a48",
  },
  background: {
    default: "#FFFFFF",
    secondary: "#0000000a",
    tableRow: "#eeeeee",
    lightTableRow: "#f7f7f7",
    tableDivider: "#e0e0e0",
    modalBg: "#f0f0f0",
  },
  gray: {
    main: "#6E6E6E",
    disabled: "#B9B9B9",
  },
  green: {
    main: "#2e7d32",
    hover: "#3d9b41",
    successOrder: "#dff0d8",
    orderHover: "#d0e9c6",
  },
  error: {
    main: "#c4271e",
    hover: "#dc4844",
    errorOrder: "#f2dede",
    orderHover: "#ebcccc",
  },
  warning: {
    main: "#da6404",
    hover: "#ee8e02",
    warningOrder: "#fcf8e3",
    orderHover: "#faf2cc",
  },
};

declare module "@mui/material/styles" {
  interface TypeText {
    primary: string;
    secondary: string;
  }

  interface Palette {
    accents: {
      main: string;
      hover: string;
    };
    gray: {
      main: string;
      disabled: string;
    };
  }

  interface PaletteOptions {
    accents?: {
      main?: string;
      hover?: string;
    };
    gray?: {
      main?: string;
      disabled?: string;
    };
  }
}
